import { Link } from "react-router-dom";

export default function ProductCard({ productProp, onSelect }) {
  const { _id, name, price, imageUrl, isNew, recommended } = productProp;

  const handleClick = (e) => {
    e.preventDefault();
    onSelect();
  };

  return (
    <div className="product-card">
      {/* Image */}
      <div className="product-image-wrapper">
        <img
          src={imageUrl || "/placeholder-image.jpg"}
          alt={name}
          className="product-image"
        />

        {/* Badges */}
        {(isNew || recommended) && (
          <div className="product-badges">
            {isNew && (
              <span className="product-badge product-badge-new">New</span>
            )}

            {recommended && (
              <span className="product-badge product-badge-recommended">
                Favorite
              </span>
            )}
          </div>
        )}
      </div>

      {/* Product Info */}
      <div className="product-info">
        <h3 className="product-name">{name}</h3>

        <div className="product-bottom-row">
          <span className="product-price">PhP {price}</span>

          <Link
            to={`/products/${_id}`}
            className="product-details-button"
            onClick={handleClick}
          >
            Details
          </Link>
        </div>
      </div>
    </div>
  );
}
